var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`min-width:${_vm.barChartVisitacao.chartData.labels.length * 8}px;max-width:100%;`)},[_c('bar-chart',{attrs:{"id":"bar-chart-visitacao","height":250,"chart-data":_vm.barChartVisitacao.chartData,"extra-options":_vm.barChartVisitacao.extraOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }